import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import StarRating from "./StarRating";
import ReviewCard from "./ReviewCard";
import ShowMoreButtonStatic from "../web-pages/ShowMoreButtonStatic";

const ReviewsSection = ({
  overallRating,
  reviews = [],
  mockupId,
  showAddReviewButton = false,
  onAddReviewClick,
  onEditReviewClick,
  has_user_reviewed = false,
  mockupUserId,
}) => {
  const navigate = useNavigate();
  const { userid } = useSelector((state) => state.auth);
  const [isOwnMockup, setIsOwnMockup] = useState(false);
  useEffect(() => {
    setIsOwnMockup(userid == mockupUserId);
  }, [userid, mockupUserId]);
  // Find if current user has already reviewed
  const hasUserReviewed = has_user_reviewed;

  // Display only first 4 reviews on the main page
  const displayedReviews = reviews.slice(0, 4);

  const handleShowMore = () => {
    navigate(`/mockup-reviews?id=${mockupId}`);
  };

  if (!reviews || reviews.length === 0) {
    return (
      <div className="mt-4">
        <h2 className="mb-3">Reviews</h2>
        {userid && showAddReviewButton && !isOwnMockup && (
          <div className="d-flex justify-content-center justify-content-md-start mb-3">
            <button
              className="btn red-btn rounded-3"
              onClick={onAddReviewClick}
            >
              Add a Review
            </button>
          </div>
        )}
        <p className="text-muted text-center">No reviews yet. Be the first to review!</p>
      </div>
    );
  }

  const handleReviewButtonClick = () => {
    if (hasUserReviewed && onEditReviewClick) {
      const userReview = reviews.find(review => review.user === userid);
      onEditReviewClick(userReview);
    } else if (onAddReviewClick) {
      onAddReviewClick();
    }
  };

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Reviews</h2>
        { userid && showAddReviewButton && !isOwnMockup && (
          <button
            className="btn red-btn rounded-3"
            onClick={handleReviewButtonClick}
          >
            {hasUserReviewed ? "Edit Review" : "Add a Review"}
          </button>
        )}
      </div>

      {/* Overall Rating */}
      {overallRating !== undefined && overallRating !== null && (
        <div className="mb-4">
          <div className="d-flex align-items-center gap-2">
            <StarRating rating={overallRating} readOnly={true} size="medium" />
            <span className="ms-2" style={{ fontSize: "16px", fontWeight: "500" }}>
              {Number(overallRating)?.toFixed(1)} out of 5
            </span>
          </div>
        </div>
      )}

      {/* Reviews List */}
      <div className="reviews-container">
        {displayedReviews.map((review, index) => (
          <ReviewCard key={review?.id || index} review={review} />
        ))}
      </div>

      {/* Show More Button */}
      {reviews.length > 1 && (
        <div className="d-flex justify-content-end mt-3">
          <ShowMoreButtonStatic onClick={handleShowMore} />
        </div>
      )}
    </div>
  );
};

export default ReviewsSection;

